/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
class s{constructor(s,t){this.isDraped=s,this.domain=t}}export{s as SnappingHint};
